import { assertInterface } from 'app-components/utils/core';

import { assert, verify } from 'utils/assert';

assertInterface.assertInterfaceInit({ assert, verify });
